import script from "./VBackdrop.vue?vue&type=script&lang=ts&setup=true"
export * from "./VBackdrop.vue?vue&type=script&lang=ts&setup=true"

import "./VBackdrop.vue?vue&type=style&index=0&id=0b6afabb&lang=sass"

const __exports__ = script;

export default __exports__